import { Component } from '@angular/core';
import {BaseState} from "@base/entities/BaseEntities";
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";
import {EnumNotificationStatuses} from "@core/framework/sysenums.enum";

class State extends BaseState {
    Status: EnumNotificationStatuses;
    Number: number;
    Date: Date;
}

@Component({
    selector: 'app-demo-pipes',
    templateUrl: './demo-pipes.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoPipesComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService) {
        super(A, 'DemoPipesComponent', State);
    }
    
    override OnInitComponent() {
        this.State.Number = 1234.456
        this.State.Date = new Date();
    }
}
